import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function Disclaimer() {
  return <ComingSoon title="Disclaimer" />;
}
